import { CategoryManagement } from "@components"

export default function CategoryManagementPage() {
	return <CategoryManagement />
}
